/*
 * pp-cuenta-mas.js — abre y cierra la hoja «Más» del portal en móvil.
 *
 * POR QUÉ EXISTE: el portal tiene trece secciones y la barra inferior cabe
 * cinco. Abajo de 768px el rail lateral es display:none, así que hasta el
 * 25-sep-2026 nueve secciones no tenían una sola entrada desde un teléfono.
 *
 * Lo mínimo que resuelve eso: abrir, cerrar, Escape, clic en el fondo, y
 * devolver el foco a donde estaba. Sin librerías y sin animaciones que
 * tapen el contenido si el JS no carga: el panel arranca con `hidden`, y
 * sin este archivo simplemente no se abre — nunca se queda encima.
 */
(function () {
  'use strict';

  var panel = document.querySelector('[data-pp-cuenta-mas]');
  var boton = document.querySelector('[data-pp-cuenta-mas-abrir]');
  if (!panel || !boton) return;

  var fondo = panel.querySelector('[data-pp-cuenta-mas-fondo]');
  var cerrar = panel.querySelector('[data-pp-cuenta-mas-cerrar]');
  var hoja = panel.querySelector('.pp-cmas__hoja');

  function estaAbierta() {
    return !panel.hidden;
  }

  function abrir() {
    panel.hidden = false;
    boton.setAttribute('aria-expanded', 'true');
    // El fondo de la página no debe correr detrás de la hoja.
    document.documentElement.classList.add('pp-cmas-abierta');
    // El foco entra a la hoja: si se quedara en el botón, un lector de
    // pantalla seguiría leyendo la barra de abajo como si nada se hubiera
    // abierto.
    var primero = hoja && hoja.querySelector('a, button');
    if (primero) primero.focus();
  }

  function cerrarHoja(devolverFoco) {
    panel.hidden = true;
    boton.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('pp-cmas-abierta');
    // Solo se devuelve el foco cuando el cliente cerró a propósito. Al
    // navegar a una sección, el foco es de la página nueva.
    if (devolverFoco) boton.focus();
  }

  boton.addEventListener('click', function () {
    if (estaAbierta()) cerrarHoja(true);
    else abrir();
  });

  if (cerrar) cerrar.addEventListener('click', function () { cerrarHoja(true); });
  if (fondo) fondo.addEventListener('click', function () { cerrarHoja(true); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && estaAbierta()) cerrarHoja(true);
  });

  // El foco no se sale de la hoja mientras está abierta: con `aria-modal`
  // puesto y el foco afuera, el lector anuncia una cosa y el teclado hace
  // otra.
  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !hoja) return;
    var focables = hoja.querySelectorAll('a[href], button:not([disabled])');
    if (!focables.length) return;
    var primero = focables[0];
    var ultimo = focables[focables.length - 1];
    if (e.shiftKey && document.activeElement === primero) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault();
      primero.focus();
    }
  });
})();
